import { render, staticRenderFns } from "./myExam.vue?vue&type=template&id=61a13e33&scoped=true"
import script from "./myExam.vue?vue&type=script&lang=js"
export * from "./myExam.vue?vue&type=script&lang=js"
import style0 from "./myExam.vue?vue&type=style&index=0&id=61a13e33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a13e33",
  null
  
)

export default component.exports